import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var ProductFreezeBaseInfo = function (_super) {
  __extends(ProductFreezeBaseInfo, _super);

  function ProductFreezeBaseInfo() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([Prop({
    type: Object,
    "default": function _default() {}
  })], ProductFreezeBaseInfo.prototype, "data", void 0);

  ProductFreezeBaseInfo = __decorate([Component], ProductFreezeBaseInfo);
  return ProductFreezeBaseInfo;
}(Vue);

export default ProductFreezeBaseInfo;